import React, { useState, FormEvent } from 'react';
import './HeroSectionAbout.scss';
import clouds from "../../../assets/images/clouds.png";
import plane from "../../../assets/images/HeroSectionPlane.png";
import skyBg from "../../../assets/images/SkyBg.png";
import { Flex } from 'antd';
import Honeywell from '../../../assets/images/Honeywell.png'
import RedBull from '../../../assets/images/RedBull.png';
import Skoda from '../../../assets/images/Skoda.png';
import Balmer from '../../../assets/images/Balmer.png'
import SunPharma from '../../../assets/images/SunPharma.png'
import Line from '../../../assets/images/Line.png'
import Valeo from '../../../assets/images/Valeo.png'

interface HeroSectionProps {
    title: string;
    subtitle: string;
    stats: {
        invoicesDownloaded: string;
        numberOfUsers: string;
        yearsOfService: string;
    };
}

const HeroSectionAbout = () => {
    const [email, setEmail] = useState<string>('');

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log('Email submitted:', email);
    };

    return (
        <div>
            <div className="hero-statsAbout">
                <div className='trustSection'>
                    <h1>TRUSTED BY</h1>
                </div>
                <div className='trustSection-image'>
                    <img src={Honeywell} alt="Honeywell Logo" />
                    <img src={RedBull } alt="Honeywell Logo" />
                    <img src={Skoda } alt="Honeywell Logo"/>
                    <img src={Balmer} alt="Honeywell Logo"/>
                    <img src={SunPharma} alt="Honeywell Logo"/>
                    <img src={Line} alt="Honeywell Logo"/>
                    <img src={Valeo} alt="Honeywell Logo"/>
                </div>

                {/* <div className="stat-item">
          <h2>80M</h2>
          <div className="stat-divider"></div>
          <p>INVOICES DOWNLOADED</p>
        </div>
        
        <div className="stat-item">
          <h2>200+</h2>
          <div className="stat-divider"></div>
          <p>NUMBER OF USERS</p>
        </div>
        
        <div className="stat-item">
          <h2>15</h2>
          <div className="stat-divider"></div>
          <p>YEARS OF SERVICE</p>
        </div> */}
            </div>
        </div>
    );
};

export default HeroSectionAbout;